<!--
  Copyright 2023 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="page error-page">
  <ground-header></ground-header>

  <div *ngIf="!isLoading" class="page-content">
      <img src="/assets/img/access-denied.svg">

      <ng-container *ngIf="errorType == ErrorType.GENERIC">
        <h1>Oops, something went wrong</h1>

        <h2>{{error}}</h2>
      </ng-container>

      <ng-container *ngIf="errorType == ErrorType.ACCESS_DENIED">
        <h1>Access denied</h1>

        <h2 *ngIf="accessDeniedMessage.message">{{accessDeniedMessage.message}}</h2>

        <a *ngIf="accessDeniedMessage.link" mat-flat-button color="primary" href="{{accessDeniedMessage.link}}" target="_blank">
          Click here to register
        </a>
      </ng-container>
    </div>
</div>
